/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completeTransactionReversal} from '../api'

export const useMutationCompleteTransactionReversal = createReactQueryMutationHook('completeTransactionReversal', completeTransactionReversal)
